import React, { useContext } from "react";
import { Redirect, Route, RouteProps } from "react-router-dom";
import { UserContext } from "../../auth/user-context";
export interface ProtectedRouteProps extends RouteProps {}
export const ProtectedRoute: React.FC<ProtectedRouteProps> = (pProps) => {
  const { user } = useContext(UserContext);

  return (
    <Route
      {...pProps}
      render={(props) =>
        user?.uid ? pProps.children : <Redirect to="/blog" />
      }
    />
  );
};

export default ProtectedRoute;
